/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="coupon-tile" :class="{ active: isActive, 'is-valid': coupon.valid }">
    <div class="wrapp-content">
      <div class="block-code">{{coupon.code}}</div>
      <div class="block-status">
        <span v-show="coupon.status_code">{{$t(`coupons.status.${coupon.status_code}`)}}</span>
      </div>
      <div class="block-action">
        <button class="btn btn-secondary btn-secondary-small btn-secondary-with-icon btn-rounded justify-content-between" v-show="!isActive" @click.prevent="addCoupon">
          <span class="text t-13">{{ $t('apply') }}</span>
          <svg class="o-icon"><use xlink:href="#check"></use></svg>
        </button>
        <button class="btn btn-none btn-remove-icon" type="button" @click.prevent="removeCoupon" v-show="isActive">
          <div class="wrapp-icon">
            <svg class="o-icon"><use xlink:href="#trash"></use></svg>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CouponTile',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    coupon: {
      type: Object,
      required: true
    }
  },
  methods: {
    removeCoupon () {
      return this.$emit('remove-coupon', this.coupon)
    },
    addCoupon () {
      return this.$emit('add-coupon', this.coupon)
    }
  }
}
</script>
